// Module
var code = "<template> <template if.bind=\"invalid === true\"> <validation-message accent=\"negative\"> <template replaceable part=\"invalid\">Please provide a valid value.</template> </validation-message> </template> </template> ";
// Exports
module.exports = code;